(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elmayorista-mobile-shop-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('em-mobile-shop-bar')) {
    customElements.define('em-mobile-shop-bar', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.frame = 0;
        const signal = this.controller.signal;
        const update = () => this.scheduleUpdate();
        const footers = [...document.querySelectorAll('[data-em-footer]')];
        this.footerVisible = footers.some((footer) => {
          const box = footer.getBoundingClientRect();
          return box.bottom > 0 && box.top < window.innerHeight + 72;
        });
        window.addEventListener('scroll', update, { passive: true, signal });
        window.addEventListener('resize', update, { passive: true, signal });
        document.addEventListener('focusin', update, { signal });
        document.addEventListener('focusout', update, { signal });
        this.mobile.addEventListener('change', update, { signal });
        this.footerObserver = new IntersectionObserver((entries) => {
          this.footerVisible = entries.some((entry) => entry.isIntersecting);
          this.scheduleUpdate();
        }, { rootMargin: '0px 0px 72px 0px' });
        footers.forEach((footer) => this.footerObserver.observe(footer));
        this.dialogObserver = new MutationObserver(update);
        this.dialogObserver.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['open'] });
        this.scheduleUpdate();
      }

      scheduleUpdate() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          const editing = document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
          const visible = this.mobile.matches && window.scrollY > 280 && !this.footerVisible && !editing && !document.querySelector('dialog[open]');
          this.dataset.visible = String(visible);
          this.inert = !visible;
          this.setAttribute('aria-hidden', String(!visible));
        });
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.footerObserver?.disconnect();
        this.dialogObserver?.disconnect();
        cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elmayorista-reviews-carousel"] && !Shopify.designMode) return;
  try {
    
  class EMReviewsCarousel extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.track = this.querySelector('[data-em-review-track]');
      if (!this.track) return;

      this.querySelectorAll('[data-em-review-nav]').forEach((button) => {
        button.addEventListener('click', () => {
          const direction = button.dataset.emReviewNav === 'previous' ? -1 : 1;
          const amount = Math.max(this.track.clientWidth * 0.88, 280);
          this.track.scrollBy({ left: amount * direction, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        });
      });
    }
  }

  if (!customElements.get('em-reviews-carousel')) {
    customElements.define('em-reviews-carousel', EMReviewsCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
